import React, { useState } from "react";
import "./panel.scss";
import "./tabs-v2.scss";
import { generateKey } from "./generateID";
import { motion } from "framer-motion";
import { generate_new_id } from "../helpers/random";

function TabsV2({ items = [], height, childrenHeight }) {
  const [selected, setSelected] = useState(items.length > 0 ? 0 : null);

  const [uniqueID, setUniqueID] = useState(generate_new_id("tabsv2"));

  return (
    items.length > 0 && (
      <div
        className={`grigora-editor-tabsv2 border rounded-[6px] ${
          selected ? `selected__${items[selected].key}` : ""
        }`}
        style={{ height }}
      >
        <div className="grigora-editor-tabsv2__titles flex bg-editor-bg-main rounded-[6px] p-[2px]">
          {items.map((e, index) => {
            return (
              <div
                className={`tab flex relative flex-1 border border-transparent duration-200 items-center justify-center text-grigora-base py-[5px] select-none cursor-pointer`}
                onClick={() => {
                  setSelected(index);
                }}
                key={uniqueID + e.key}
              >
                {selected === index ? (
                  <>
                    <motion.div
                      layoutId={uniqueID + "-bg"}
                      className="absolute top-0 left-0 right-0 bottom-0 rounded-[6px] bg-white z-[0]"
                    ></motion.div>
                  </>
                ) : (
                  <></>
                )}
                <span className="z-[10]">{e.label}</span>
              </div>
            );
          })}
        </div>
        <div
          className="grigora-editor-tabsv2__children"
          style={{ height: childrenHeight }}
        >
          <>{items[selected].children ? items[selected].children : null}</>
        </div>
      </div>
    )
  );
}

export default TabsV2;
